'use strict';

function normalizeExternalId(value) {
  if (value === null || value === undefined) {
    return null;
  }

  const normalized = String(value).trim();
  return normalized.length ? normalized : null;
}

function parseSettings(settings) {
  if (!settings) {
    return {};
  }
  if (typeof settings === 'object') {
    return settings;
  }

  try {
    return JSON.parse(settings);
  }
  catch (error) {
    return {};
  }
}

function getExplorosCanvasIdentity(course) {
  const settings = parseSettings(course && course.settings);
  const imsSettings = settings && settings.ims ? settings.ims : {};
  const storedCourseId = normalizeExternalId(course && course.ims_class_id);

  return {
    integrationId: normalizeExternalId(course && course.ims_id) ||
      normalizeExternalId(imsSettings.ims_id),
    courseId: storedCourseId || normalizeExternalId(imsSettings.classroom),
    sectionId: storedCourseId !== null
      ? normalizeExternalId(course && course.section_id)
      : normalizeExternalId(imsSettings.section_id)
  };
}

function isImportedCanvasCourse(canvasCourse, explorosCourse, integrationId) {
  const canvasIdentity = {
    integrationId: normalizeExternalId(integrationId),
    courseId: normalizeExternalId(canvasCourse && canvasCourse.course_id),
    sectionId: normalizeExternalId(canvasCourse && canvasCourse.section_id)
  };
  const explorosIdentity = getExplorosCanvasIdentity(explorosCourse);

  return canvasIdentity.integrationId !== null &&
    canvasIdentity.courseId !== null &&
    canvasIdentity.integrationId === explorosIdentity.integrationId &&
    canvasIdentity.courseId === explorosIdentity.courseId &&
    canvasIdentity.sectionId === explorosIdentity.sectionId;
}

module.exports = {
  getExplorosCanvasIdentity,
  isImportedCanvasCourse,
  normalizeExternalId
};
